import Lang from '@/lang';

export default {
    data: function () {
        return {
            Lang: Lang
        }
    }
}
